import Phaser from 'phaser';
import { PreloadScene } from './scenes/PreloadScene';
import { LobbyScene } from './scenes/LobbyScene';
import { GameScene } from './scenes/GameScene';
import { ReplayScene } from './scenes/ReplayScene';
import { TournamentLobbyScene } from './scenes/TournamentLobbyScene';
import { PreviewScene } from './scenes/PreviewScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.WEBGL,
  width: 1440,
  height: 768,
  parent: 'game',
  backgroundColor: '#1a2d1a',
  dom: {
    createContainer: true,
  },
  scene: [PreloadScene, LobbyScene, GameScene, ReplayScene, TournamentLobbyScene, PreviewScene],
  render: {
    antialias: true,
    antialiasGL: true,
    mipmapFilter: 'LINEAR_MIPMAP_LINEAR',
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
};

// Suppress long-press context menu on touch devices
document.getElementById('game')?.addEventListener('contextmenu', e => e.preventDefault());

// Register PWA service worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(() => {/* silently ignore */});
}

// Request landscape lock on Android/Chrome (Safari ignores this — the CSS prompt handles it)
if ('screen' in window && 'orientation' in screen) {
  (screen.orientation as ScreenOrientation & { lock?: (o: string) => Promise<void> })
    .lock?.('landscape')
    .catch(() => { /* silently ignore — not supported on iOS/desktop */ });
}

new Phaser.Game(config);
